import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import $auth from "@/services/auth";
import MemberList from '@/views/members/MemberList.vue';
import MemberDetail from '@/views/members/MemberDetail.vue';
import SMSInbox from '@/views/inbox/SMSInbox.vue';
import PriorityQueue from '@/views/members/PriorityQueue.vue';
import BacklogQueue from '@/views/members/BacklogQueue.vue';
import Insights from '@/views/insights/Insights.vue';

Vue.use(VueRouter)

const routes = [
  {path: '/',name: 'Home',component: Home},
  {path: '/members', name: 'MemberList', component: MemberList},
  {path: '/members/:id', name: 'MemberDetail', component: MemberDetail},
  {path: '/inbox/sms', name: 'SMSInbox', component: SMSInbox},
  {path: '/priorityqueue', name: 'PriorityQueue', component: PriorityQueue},
  {path: '/backlog', name: 'BacklogQueue', component: BacklogQueue},
  {path: '/insights', name: 'Insights', component: Insights},
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    $auth.ensureLoggedIn();
    next();
});

export default router
